import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { ViewModelForm } from "gw-portals-viewmodel-react";
import metadata from "./WCMotorDetailsTable.metadata.json5";
import "./WCMotorDetailsTable.messages";

const getCell = (items, index, property) => {
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

export function WCMotorDetailsTable({ data }) {
    const overrides = {
        wcMotorDetailsTable: {
            data: data,
        },
        
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellValue: getCell,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

WCMotorDetailsTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

WCMotorDetailsTable.defaultProps = {
    data: [],
};

export default WCMotorDetailsTable;
